'use client';
import React, { useEffect, useState } from 'react';

import { EventBus } from '@/shared/utils';
import { OnboardingEvents, OnboardingEventKeys } from '@/profile';
import { AuthEventKeys, AuthEvents } from 'src/modules/auth/events';

interface BackgroundWavesProps {
  eventBus: EventBus<AuthEvents | OnboardingEvents>; // Accettiamo un solo tipo di EventBus
}

// Mappatura parziale degli eventi a classi CSS
const eventClassMapping: Partial<Record<string, string>> = {
  [AuthEventKeys.login.view]: 'bg-wave',
  [AuthEventKeys.oidcLogin.view]: 'bg-wave',
  [AuthEventKeys.register.view]: 'bg-wave',
  [AuthEventKeys.register.success]: 'bg-wave',
  [AuthEventKeys.forgotPassword.view]: 'bg-wave',
  [AuthEventKeys.forgotPassword.success]: 'bg-wave',
  [AuthEventKeys.newPassword.view]: 'bg-wave',
  [OnboardingEventKeys.start.view]: 'bg-wave',
};

const BackgroundWavesScreen: React.FC<BackgroundWavesProps> = ({ eventBus }) => {
  const [activeClass, setActiveClass] = useState<string>('');

  useEffect(() => {
    // Funzione per aggiornare la classe CSS in base all'evento ricevuto
    const handleEvent = (eventKey: string) => {
      const cssClass = eventClassMapping[eventKey] || '';
      setActiveClass(cssClass);
    };

    // Ottieni tutte le chiavi degli eventi presenti nella mappatura
    const subscribedEvents = Object.keys(eventClassMapping) as string[];

    // Sottoscrivi solo agli eventi presenti nel mapping
    subscribedEvents.forEach((eventKey) => {
      eventBus.on(eventKey as any, () => handleEvent(eventKey)); // Type assertion per qualsiasi tipo di evento
    });

    // Cleanup per rimuovere le sottoscrizioni agli eventi quando il componente viene smontato
    return () => {
      subscribedEvents.forEach((eventKey) => {
        eventBus.off(eventKey as any, () => handleEvent(eventKey));
      });
    };
  }, [eventBus]);

  return (
    <div aria-label="Background Waves Screen" className={`fixed inset-0 h-screen ${activeClass}`} />
  );
};

export default BackgroundWavesScreen;
